import React, { FC } from 'react';
import { TextButton } from '../../../../commons/buttons/TextButton';

interface SocialItemProps {
  buttonLabel: string;
  handleClick: () => void;
  infoText: string;
  icon: JSX.Element;
  isDisabled: boolean;
}

export const SocialItem: FC<SocialItemProps> = ({ buttonLabel, handleClick, infoText, icon, isDisabled }) => {
  return (
    <div className="social-item-container">
      {icon}
      <p className="social-item-container__text">{infoText}</p>
      <TextButton
        label={buttonLabel}
        handleClick={handleClick}
        className="primary"
        isArrow={false}
        isDisabled={isDisabled}
      />
    </div>
  );
};
